import { Form, Row } from 'antd';
import React from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import FormWrapper from 'components/molecules/FormWrapper';

interface IDLTpotvrzeni {
    setDltConsent: React.Dispatch<React.SetStateAction<boolean>>;
}

const DLTpotvrzeni: React.FC<IDLTpotvrzeni> = ({ setDltConsent }) => {
    const [form] = Form.useForm();

    return (
        <FormWrapper onFinish={() => setDltConsent(true)} name="DLTpotvrzeni" outForm={form}>
            <Title level={4} text="AMLZ_DLT_POTVRZENI_TITLE" />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_SUB'}
                style={{
                    display: 'block',
                    fontWeight: 'bold',
                    paddingBottom: 20
                }}
            />

            <Title
                level={5}
                dividerTitle={true}
                text={'AMLZ_DLT_POTVRZENI_I'}
                style={{
                    display: 'block',
                    paddingBottom: 20
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_I1'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_I2'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_I3'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_I4'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Title
                level={5}
                dividerTitle={true}
                text={'AMLZ_DLT_POTVRZENI_II'}
                style={{
                    paddingBottom: 20
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_II1'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_II2'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_II3'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Title
                level={5}
                dividerTitle={true}
                text={'AMLZ_DLT_POTVRZENI_III'}
                style={{
                    paddingBottom: 20
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_III1'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_III2'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_III3'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_III4'}
                style={{
                    display: 'block',
                    marginBottom: 8
                }}
            />
            <Paragraph
                text={'AMLZ_DLT_POTVRZENI_III5'}
                style={{
                    marginBottom: 26,
                    display: 'block'
                }}
            />
            <CheckboxComponent
                style={{
                    display: 'block'
                }}
                name={'consent'}
                checkboxText="AMLZ_DLT_POTVRZENI_CHECKBOX"
            />
            <Row className="button-row">
                <ButtonComponent
                    type="primary"
                    onClick={() => {
                        form.submit();
                    }}
                    id="C-1PokracovatBtn"
                    buttontext="POKRACOVAT"
                />
            </Row>
        </FormWrapper>
    );
};
export default DLTpotvrzeni;
